module.exports = __webpack_public_path__ + "img/paper-line.430e2cdf.svg";